"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
class EducationCodes {
}
EducationCodes.SOSU_HELPER = "5147";
EducationCodes.SOSU_ASSIST = "5152";
EducationCodes.NURSE = "5166";
EducationCodes.HEALTH_VISITOR = "5168";
EducationCodes.MIDWIFE = "5175";
EducationCodes.PHARMACONOMIST = "5177";
EducationCodes.PHARMACIST = "5425";
EducationCodes.DENTIST = "5433";
EducationCodes.DOCTOR = "7170";
EducationCodes.PHARMACIST_BACH = "7420";
EducationCodes.PHARMACIST_WITH_PRESCRIPTION_RIGHTS = "B511";
exports.default = EducationCodes;
//# sourceMappingURL=EducationCodes.js.map